/**
 * Location Master Data Types
 *
 * Shared types for the Country/State/City reference data and the
 * user-submitted location suggestion queue — used by frontend and backend.
 */
export var LocationSuggestionStatus;
(function (LocationSuggestionStatus) {
    LocationSuggestionStatus["PENDING"] = "PENDING";
    LocationSuggestionStatus["APPROVED"] = "APPROVED";
    LocationSuggestionStatus["MAPPED"] = "MAPPED";
    LocationSuggestionStatus["REJECTED"] = "REJECTED";
})(LocationSuggestionStatus || (LocationSuggestionStatus = {}));
